import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { SystemLogAreaOption } from '../system-logs-area-option.interface';

export const systemLogAreaOptionActions = createEagerSelectActions<SystemLogAreaOption>('[System Log Area Options]');
